// extracted by mini-css-extract-plugin
export var button = "read-more-module--button--zWKsU";
export var buttonLess = "read-more-module--button-less--F0FMC";